export default class Property {
  constructor({
    scarcity = [],
    position = [],
    isPlayingGw = true,
  } = {}) {
    this.scarcity = scarcity;
    this.position = position;
    this.isPlayingGw = isPlayingGw;
  }
}
